


































import { Component, Vue } from 'vue-property-decorator'
import _get from 'lodash/get'

@Component
export default class Profile extends Vue {
  form = {
    email: '',
    name: '',
    oldPassword: '',
    newPassword: ''
  }
  loading: boolean = false
  rules = {
    name: [
      { required: true, message: 'Name must not be empty', trigger: 'blur' },
    ],
  }

  get name() {
    return this.$store.state.userStore.name
  }

  get email() {
    return this.$store.state.userStore.email
  }

  mounted() {
    this.form = {
      name: this.name,
      email: this.email,
      oldPassword: '',
      newPassword: ''
    }
  }

  updateUser() {
    this.loading = true
    this.$store.dispatch('updateMe', this.form)
    .then(() => {
      this.loading = false
      this.$message.success('Profile Updated')
    })
    .catch(e => {
      this.loading = false
      this.$message.error(JSON.stringify(_get(e, 'response.data.messages.error', 'Something went wrong')))
    })
  }
}

